import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import SingleBlock from './singleBlock';
import BiserialBlock from './biserialBlock';
import TriserialBlock from './triserialBlock';
/**
 * todo
 *   优化组件(根据原组件整理 暂未优化)
 */
var MixedBlocks = function MixedBlocks(_ref) {
  var pid = _ref.pid,
    id = _ref.id,
    config = _ref.config,
    onClick = _ref.onClick,
    render = _ref.render;
  var rowNum = config.rowNum,
    rowType = config.rowType,
    item1 = config.item1,
    item2 = config.item2,
    item3 = config.item3;
  var clickHandler = function clickHandler(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(Object.assign(Object.assign({}, e), {
      componentId: id,
      pid: pid,
      render: render
    }));
  };
  var _useMemo = useMemo(function () {
      switch (rowNum) {
        case 3:
          return {
            data: [Object.assign(Object.assign({}, item1), {
              key: 'item1'
            }), Object.assign(Object.assign({}, item2), {
              key: 'item2'
            }), Object.assign(Object.assign({}, item3), {
              key: 'item3'
            })],
            Child: TriserialBlock
          };
        case 2:
          return {
            data: [Object.assign(Object.assign({}, item1), {
              key: 'item1'
            }), Object.assign(Object.assign({}, item2), {
              key: 'item2'
            })],
            Child: BiserialBlock
          };
        default:
          return {
            data: [Object.assign(Object.assign({}, item1), {
              key: 'item1'
            })],
            Child: SingleBlock
          };
      }
    }, [rowNum, item1, item2, item3]),
    data = _useMemo.data,
    Child = _useMemo.Child;
  return _jsx("div", Object.assign({
    className: "mixedBlocksContent",
    "data-componentid": id,
    "data-pid": pid
  }, {
    children: _jsx("div", Object.assign({
      className: "mixBox"
    }, {
      children: data.map(function (item) {
        return _jsx(Child, {
          config: item,
          rowType: rowType,
          onClick: clickHandler
        }, item.key);
      })
    }))
  }));
};
MixedBlocks.displayName = 'MixedBlocks';
MixedBlocks.defaultProps = {
  config: {}
};
export default MixedBlocks;